import { OverlayPanel } from "primereact/overlaypanel";
import { classNames } from "primereact/utils";

import { UserContactCard } from "@/shared/components/user-contact-card";

import { PANEL_FLUSH_CLASS } from "./user-info-card.constants";
import styles from "./user-info-card.module.scss";
import type { UserInfoCardViewModel } from "./types-user-info-card";

/** Gatilho na linha e o cartão do hover (Figma info-user-card 9961:116556). */
export function UserInfoCardView({
  panelRef,
  children,
  triggerTestId,
  card,
  abrir,
  agendarFechamento,
}: UserInfoCardViewModel) {
  return (
    <>
      <span
        className={styles.trigger}
        onMouseEnter={abrir}
        onMouseLeave={agendarFechamento}
        data-testid={triggerTestId}
      >
        {children}
      </span>

      <OverlayPanel ref={panelRef} className={classNames(PANEL_FLUSH_CLASS, styles.panel)}>
        <UserContactCard {...card} className={styles.cartao} />
      </OverlayPanel>
    </>
  );
}
